/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const questionDropoffDataSchema = z.object({
	questionId: z.string(),
	position: z.number(),
	label: z.string(),
	type: z.string(),
	attribute: z.string().nullable(),
	sessionsViewed: z.number(),
	sessionsAnswered: z.number(),
	dropoffCount: z.number(),
	dropoffRate: z.number(),
	cumulativeDropoffRate: z.number(),
})

export type QuestionDropoffDataSchema = z.infer<typeof questionDropoffDataSchema>
